import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';
import { SizeField as EditComponent } from '../tsx/SizeField';

export class SizeField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    constructor(glob, title: string, validators?: any, defaultVal: any = {}, options?, directionOptions?) {
        super(glob, title, SizeField.defaultValidators, validators, defaultVal, options, directionOptions);
    }
}
